"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const input_1 = require("../../input");
const TextInput = ({ control, name, label, maxLength, disabled, rules, placeholder, testid, disableLastpass, autocomplete, }) => {
    const { field, fieldState: { error }, } = (0, react_hook_form_1.useController)({ control, name, rules });
    return (react_1.default.createElement(input_1.Input, { maxLength: maxLength, type: 'text', size: 'full-width', label: label, disabled: field.disabled || disabled, placeholder: (0, maybe_unwrap_1.unwrapMaybe)(placeholder), 
        // @ts-expect-error
        innerRef: field.ref, value: field.value, onChange: field.onChange, onBlur: field.onBlur, name: field.name, hasError: (0, util_1.isDefined)(error), errorMessage: error?.message, testid: testid, disableLastpass: disableLastpass, autocomplete: autocomplete }));
};
exports.TextInput = TextInput;
